/**
 * @param {Editor} editor
 */
function register(editor) {
    function template(title, html = '') {
        return `
            <sup contentEditable="false" class="footnote" title="${title}" data-html="${html}">[*]</sup>
        `;
    }

    function footnoteDialog(value = '', replaceTarget = false) {
        editor.windowManager.open({
            title: 'Add Footnote',
            body: {
                type: 'panel',
                items: [
                    {
                        type: 'textarea',
                        name: 'footnote',
                        label: 'Footnote Content',
                    },
                ],
            },
            initialData: {
                footnote: decodeURI(value),
            },
            buttons: [
                {
                    type: 'cancel',
                    text: 'Close',
                },
                {
                    type: 'submit',
                    text: 'Insert',
                    primary: true,
                },
            ],
            onSubmit(api) {
                const data = api.getData();
                const content = data.footnote;
                const encodedContent = encodeURI(content);

                if (replaceTarget) {
                    replaceTarget.setAttribute('title', content);
                    replaceTarget.setAttribute('data-html', encodedContent);
                } else {
                    editor.insertContent(template(content, encodedContent));
                }
                api.close();
            },
        });
    }

    editor.ui.registry.addButton('footnoteplugin', {
        text: 'Footnote',
        onAction() {
            footnoteDialog('');
        },
    });

    editor.on('Click', e => {
        if (!e.target.classList.contains('footnote')) return;
        footnoteDialog(e.target.getAttribute('data-html') || '', e.target);
    });

    editor.on('PostProcess', e => {
        const temp = document.createElement('div');
        temp.innerHTML = e.content;
        const contentEditableEls = temp.querySelectorAll('[contentEditable]');
        for (let i = 0; i < contentEditableEls.length; i += 1) {
            contentEditableEls[i].removeAttribute('contentEditable');
        }
        e.content = temp.innerHTML;
    });

    editor.on('SetContent', () => {
        const body = editor.getBody();
        const els = body.querySelectorAll('sup.footnote');
        for (let i = 0; i < els.length; i += 1) {
            els[i].setAttribute('contentEditable', false);
            els[i].textContent = '[*]';
        }
    });
}

/**
 * @return {register}
 */
export function getPlugin() {
    return register;
}
